import { useState,useEffect  } from "react";


const ApiHelper=(formData,url,setHasErrorFunc,token,accessHeader,setLoadingFunc,navigateToResult,email)=>
{
//alert("ApiHelper");
    //console.log("ApiHelper", formData);
 
    // POST request using fetch inside useEffect React hook
 const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json',
    "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Token":token,
        "AccessHeader":accessHeader
  },
  //mode: "no-cors",
    body: JSON.stringify(formData)
};
setLoadingFunc(true);
setHasErrorFunc(false);

fetch(url, requestOptions)
    .then(async response => {
        const isJson = response.headers.get('content-type')?.includes('application/json');
        const data = isJson && await response.json();


        // check for error response
        if (!response.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || response.status;
            return Promise.reject(error);
        }
        setHasErrorFunc(false);

        //let text = await response.text(); // read response body as text
        
        //setOkFunc(true);
        navigateToResult(data.dayBookNo,data.email,email);
    })
    
    
    .catch(error => {
        setHasErrorFunc(true);
        setLoadingFunc(false);
        console.error('There was an error!', error);
    });



}

export default ApiHelper